import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterClinique'
})
export class FilterCliniquePipe implements PipeTransform {
 transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      return (item.name.toLowerCase().includes(searchText) || item.address.toLowerCase().includes(searchText)   ||   item.government.toLowerCase().includes(searchText) );

    });
    
  }
}
